// src/app/features/dashboard/widgets/ScarletWell/ScarletWellTotalScore.js
import React, { useEffect } from 'react'
import { Box, Typography, Card, Divider } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import useScarletWellTotalScoreStyles from './ScarletWellTotalScoreStyles'
import {
  fetchScarletWellCheckInData,
  selectScarletWellData,
  selectScarletWellStatus,
} from './scarletWellSlice'
import Loading from '../helpers/Loading'
import { ErrorMessage } from '../../DashboardComponents/ErrorMessages/ErrorMsg'
import BackButtonNavBar from '../../../../CommonComponents/BackButtonNavBar/BackButtonNavBar'

function ScarletWellTotalScore() {
  const classes = useScarletWellTotalScoreStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const surveyData = useSelector(selectScarletWellData)
  const status = useSelector(selectScarletWellStatus)
  const drawerIsOpen = useSelector((state) => state.navigation.drawerIsOpen)

  // TODO: start here and map through the data to create the table. using data.totalScore
  useEffect(() => {
    dispatch(fetchScarletWellCheckInData())
  }, [dispatch])

  const renderContent = () => {
    if (status === 'pending' || status === 'idle') {
      return (
        <Box className={classes.stateContainer}>
          <Loading />
        </Box>
      )
    }

    if (status === 'error') {
      return (
        <Box className={classes.stateContainer}>
          <ErrorMessage />
        </Box>
      )
    }

    // Calculate the average score from live data
    let calculatedTotalScore = '0.00'

    // Extract and format date to mm/dd/yyyy
    let totalScoreDate = surveyData?.totalScore?.scores?.[0]?.date
    if (totalScoreDate) {
      totalScoreDate = new Date(totalScoreDate).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
    }

    if (surveyData?.totalScore?.scores?.[0]?.answers.length > 0) {
      const scoresArray = surveyData.totalScore.scores[0].answers
      const sum = scoresArray.reduce((acc, val) => acc + val, 0)
      calculatedTotalScore = (sum / scoresArray.length).toFixed(2)
    }

    const formatDate = (dateString) => {
      if (!dateString) return ''
      return new Date(dateString).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
    }

    return (
      <Card className={classes.cardRoot} elevation={0}>
        <Box className={classes.headerBox}>
          <Typography variant="h2" className={classes.headerText}>
            Total Score
          </Typography>
        </Box>
        <Box className={classes.contentBox}>
          <Box className={classes.topRow}>
            <Typography variant="h4">Wellness Engagement Score</Typography>
            <Typography variant="h4">{totalScoreDate}</Typography>
          </Box>

          <Box className={classes.scoreArea}>
            <Typography variant="h2" className={classes.totalLabel}>
              Total:
            </Typography>
            <Box className={classes.scoreValueBox}>
              <Typography variant="h2" className={classes.totalScoreLabel}>
                {calculatedTotalScore}
              </Typography>
            </Box>
          </Box>

          <Typography variant="h5" className={classes.mediumText}>
            This score is the average of all wellness categories combined for
            the above date
          </Typography>

          <Divider className={classes.divider} />

          <Typography variant="h5" className={classes.mediumText}>
            Track your status over time using the table below
          </Typography>

          <Box className={classes.tableOuterShell}>
            {/* Left Category Column (Static) */}
            <Box className={classes.tableLeftColumn}>
              <Box className={classes.tableHeaderEmpty} />
              {surveyData?.totalScore?.categories?.map((cat, idx) => (
                <Box
                  key={cat.categoryId}
                  className={`${classes.tableCell} ${
                    idx % 2 === 0 ? classes.oddRow : classes.evenRow
                  }`}
                >
                  <Typography variant="h6" className={classes.categoryText}>
                    {cat.categoryTitle}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Score Columns Wrapper (Scrollable) */}
            <Box className={classes.tableScoresWrapper}>
              {surveyData?.totalScore?.scores?.map((scoreObj) => (
                <Box
                  key={formatDate(scoreObj.date)}
                  className={classes.tableScoreColumn}
                >
                  <Box className={classes.tableHeaderCell}>
                    <Typography
                      variant="body1"
                      className={classes.tableDateText}
                    >
                      {formatDate(scoreObj.date)}
                    </Typography>
                  </Box>
                  {scoreObj.answers?.map((answer, rowIdx) => (
                    <Box
                      key={`${scoreObj.date}-${answer}`}
                      className={`${classes.tableCellCenter} ${
                        rowIdx % 2 === 0 ? classes.oddRow : classes.evenRow
                      }`}
                    >
                      <Typography
                        variant="body1"
                        className={classes.tableCellAnswer}
                      >
                        {answer.toFixed(2)}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Card>
    )
  }

  return (
    <Box
      className={
        drawerIsOpen ? classes.centerPageDrawerOpen : classes.centerPage
      }
      id="main-content"
    >
      <Box>
        <BackButtonNavBar
          onClick={() => history.push('/')}
          name="Back"
          topMargin={{ xs: 0, sm: 0, md: 64, lg: 64 }}
        />
      </Box>
      <Box className={classes.pageContainer}>{renderContent()}</Box>
    </Box>
  )
}

export default ScarletWellTotalScore
